import { stringifyGraph } from '@/clients/http'
import { ProductModel as ProductApi } from '@/http/models/Product/Product'
import { toast } from 'sonner'

import { useCallback, useState } from 'react'

import { ProductModel } from '@/types/model/Product'

export const useFetchProduct = () => {
  const [product, setProduct] = useState<ProductModel.Product | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchProduct = useCallback(async (id: string) => {
    if (!id) return

    setIsLoading(true)
    setError(null)

    try {
      const response = await ProductApi.getById({
        params: { id },
        query: {
          graph_enc: stringifyGraph({
            '*': true,
            name: true,
            attributes: { name: true },
            thumbnail_id: { path: true },
            variations: {
              '*': true,
              name: true,
              attribute_value_ids: true,
              images: { path: true },
              attributeValues: { '*': true },
              'stocks(quantity!=0)': {
                _id: true,
                stock_purchase_transaction_id: true,
                quantity: true,
                expiry_date: true,
              },
            },
          }),
        },
      })

      if (!response.success || !response.data?.result) {
        throw new Error(response.error?.data?.message || 'Failed to fetch product')
      }

      setProduct(response.data.result)
      return response.data.result
    } catch (err: any) {
      const message = err.message || 'Failed to load product'
      setError(message)
      toast.error(message)
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    product,
    isLoading,
    error,
    fetchProduct,
    setProduct,
  }
}
